export const PLACEHOLDER_API_KEY = 'API ключ';
export const PLACEHOLDER_TOKEN = 'Токен';
export const PLACEHOLDER_YML_LINK = 'Ссылка на фид';
export const PLACEHOLDER_AUTH_TOKEN = 'Авторизационный токен';
